import { useSourceAccounts } from '@/contexts/useSourceAccounts';

import { AccountIndicator } from './accountIndicator';

export const SourceAccountIndicator = ({
  providerAccountId,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
  copyable = true,
}: {
  providerAccountId: string;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
  copyable?: boolean;
}) => {
  const { sourceAccounts } = useSourceAccounts();
  const account = sourceAccounts?.find(
    (a) => a.providerAccountId === providerAccountId
  );

  return account ? (
    <AccountIndicator
      account={account}
      showCloudIndicator={showCloudIndicator}
      showAccountName={showAccountName}
      showAccountId={showAccountId}
      copyable={copyable}
    />
  ) : null;
};
